import styled from "styled-components";

import Paper from "components/Layout/Paper";

import { COLORS } from "constants/colorScheme";

const CARD_HEIGHT = 56;

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  background-color: ${COLORS.WHITE};
  border-radius: 8px;
`;

export const ImageContainer = styled.div`
  padding: 16px;
  min-width: 56px;
  min-height: ${CARD_HEIGHT}px;

  border-radius: 8px;
`;

export const Image = styled.div`
  min-height: 24px;
  min-width: 24px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: center;

  height: ${CARD_HEIGHT}px;
  width: 100%;

  padding: 24px 24px 24px 8px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ControlWrapper = styled.div`
  margin-right: 40px;
`;
